import React from "react";
import { useDemoContext } from "../context/DemoContext";

const DemoBanner: React.FC = () => {
  const { isDemoMode } = useDemoContext();

  if (!isDemoMode) return null;

  return (
    <div style={{
      position: "fixed",
      top: 60,
      left: 0,
      right: 0,
      zIndex: 49,
      backgroundColor: "#f59e0b",
      color: "#1c1917",
      textAlign: "center",
      padding: "8px 16px",
      fontWeight: 600,
      fontSize: "14px",
      letterSpacing: "0.3px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    }}>
      MODE DÉMO — Vous interagissez avec des données fictives.
    </div>
  );
};

export default DemoBanner;
